import Head from "next/head";
import { useRouter } from "next/router";
import { BlogArticleDetail } from "modules/Blog/BlogArticleDetail";
import { GetServerSideProps } from "next";
import { serverApiFetcher, ServerApiFetcherResponse } from "lib/apiFetcher";
import { useBlogArticleDetailApi } from "modules/Blog/blogApi";
import { useEffect, useState } from "react";
import { SocialMeta } from "modules/Meta/SocialMeta";


const BlogDetail: React.FC = () => {
  const [data, setData] = useState(null);
  const router = useRouter();

  const slug =
    typeof router.query.blogSlug == "string" ? router.query.blogSlug : "";

  const blogArticleDetailApi = useBlogArticleDetailApi(slug);
  // const data = blogArticleDetailApi.data?.data;
  // const betaUrl = "https://beta-pwa.gokampus.com";

  useEffect(() => {
    blogArticleDetailApi.initialFetch(
      {
        slug,
      },
      {
        onSuccess(res) {
          setData(res?.data);
        },
      }
    );

  }, [slug]);


  return (
    <div className="">
      <SocialMeta
        title={data?.title + " | goKampus"}
        image={data?.image_url}
        url={`https://www.gokampus.com/blog/${data?.slug}?hideHeader=false`}
        description={
          data?.content?.match(/<p>(.*)<\/p>/m)
            ? data?.content
                ?.match(/<p>(.*)<\/p>/m)[0]
                .replaceAll("<p>", "")
                .replaceAll("</p>", "")
                .replace(/<.*>/g, "")
            : null
        }
        type="article"
      />

      <main>
        <BlogArticleDetail slug={slug} data={data} />
      </main>
    </div>
  );
};

export default BlogDetail;
